import React from 'react';
import { Grid, TextField } from '@material-ui/core';
// common validator for EntitySampleRangeConfigurator
export const EntitySampleRangeValidator = config => {
    const { min, max } = config;
    const minError = typeof min !== 'number' ? 'Min value is required.' : undefined;
    const maxError = typeof max !== 'number'
        ? 'Max value is required.'
        : typeof min === 'number' && max < min
            ? 'Max value is less than Min value.'
            : undefined;
    return minError || maxError ? { min: minError, max: maxError } : undefined;
};
const defaultRange = {
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER
};
export function EntitySampleRangeConfigurator(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const float = (options === null || options === void 0 ? void 0 : options.float) || false;
    const range = {
        min: {
            min: (_b = (_a = options === null || options === void 0 ? void 0 : options.minRange) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : defaultRange.min,
            max: (_d = (_c = options === null || options === void 0 ? void 0 : options.minRange) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : defaultRange.max
        },
        max: {
            min: (_f = (_e = options === null || options === void 0 ? void 0 : options.maxRange) === null || _e === void 0 ? void 0 : _e.min) !== null && _f !== void 0 ? _f : defaultRange.min,
            max: (_h = (_g = options === null || options === void 0 ? void 0 : options.maxRange) === null || _g === void 0 ? void 0 : _g.max) !== null && _h !== void 0 ? _h : defaultRange.max
        }
    };
    return props => {
        const { column, config, disabled, validate, onChange } = props;
        const errors = (validate === null || validate === void 0 ? void 0 : validate(config, column)) || {};
        const getValue = (value) => {
            value = value !== null && value !== void 0 ? value : '';
            return float ? value : value.toString();
        };
        const handleChange = (event, type) => {
            const result = event.target.value;
            if (!result) {
                onChange === null || onChange === void 0 ? void 0 : onChange({ [type]: undefined });
                return;
            }
            const value = float ? parseFloat(result) : parseInt(result);
            if (isFinite(value) &&
                range[type].min <= value &&
                range[type].max >= value) {
                onChange === null || onChange === void 0 ? void 0 : onChange({ [type]: value });
            }
        };
        return (React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(TextField, { fullWidth: true, label: 'Min', size: 'small', type: 'number', variant: 'outlined', disabled: disabled, error: !!errors.min, value: getValue(config.min), helperText: errors.min || 'Set the minimum range', onChange: event => handleChange(event, 'min') })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(TextField, { fullWidth: true, label: 'Max', size: 'small', type: 'number', variant: 'outlined', disabled: disabled, error: !!errors.max, value: getValue(config.max), helperText: errors.max || 'Set the maximum range', onChange: event => handleChange(event, 'max') }))));
    };
}
//# sourceMappingURL=EntitySampleRangeConfigurator.js.map